/****************************************************
 * Module Name:  usersettingsProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class UsersettingsProxy {
  static GetAllUsersettings = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/usersetting",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllUsersettingsDetail = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/usersetting/detail",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleUsersettings = (UsersettingId, callback) => {
    let params = {
      id: UsersettingId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/usersetting",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleUsersettingsDetailByUserName = (userName, callback) => {
    let params = {
      username: userName,
    };
    restAPICall(
      Constants.MANAGER_URL + "/usersetting/detail",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleUsersettingsDetail = (UsersettingId, callback) => {
    let params = {
      id: UsersettingId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/usersetting/detail",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckUsersettingsAvailable = (usersetting, callback) => {
    let params = {
      usersetting: usersetting,
    };

    restAPICall(
      Constants.MANAGER_URL + "/usersetting/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddUsersettings = (usersetting, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/usersetting",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(usersetting),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateUsersettings = (usersetting, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/usersetting",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(usersetting),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetIsInvoiceOpen = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/usersetting/openinvoice",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
